import useLogoutFromGestao from 'hooks/useLogoutFromGestao';
import GlobalStyles from 'styles/GlobalStyles';

import BackdropLoading from 'components/BackdropLoading';

import AppRoutes from './routes';

function App() {
  const { isLoading } = useLogoutFromGestao();
  return (
    <>
      {isLoading && <BackdropLoading />}
      <GlobalStyles />
      <AppRoutes />
    </>
  );
}

export default App;
